import ProductListingSearch from './components/product-instantsearch/index.js'
import { createTypesenseProvider } from './components/product-instantsearch/providers/typesense.js'
import { installTrustedShopsDisconnectGuard } from './components/product-instantsearch/trusted-shops.js'

installTrustedShopsDisconnectGuard()

const rootElement = document.querySelector('[data-product-listing]')

if (rootElement) {
  try {
    const listing = new ProductListingSearch(rootElement, createTypesenseProvider(rootElement))

    listing.start().catch((error) => {
      listing.showError()
      console.error('Product listing could not be initialized.', error)
    })
  } catch (error) {
    console.error('Product listing could not be initialized.', error)
  }
}
